import React from 'react';

function IconDashboard({ color }: { color?: string }) {
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" fill="none">
      <path
        d="M8 2.50002C4.31809 2.50002 1.33333 5.48478 1.33333 9.16669C1.33333 11.0078 2.07879 12.6736 3.28596 13.8808C3.54631 14.1411 3.5463 14.5632 3.28595 14.8236C3.0256 15.0839 2.60349 15.0839 2.34314 14.8236C0.89616 13.3765 0 11.3756 0 9.16669C0 4.7484 3.58171 1.16669 8 1.16669C12.4183 1.16669 16 4.7484 16 9.16669C16 11.3756 15.1039 13.3765 13.6569 14.8236C13.3965 15.0839 12.9744 15.0839 12.7141 14.8236C12.4537 14.5632 12.4537 14.1411 12.7141 13.8808C13.9212 12.6736 14.6667 11.0078 14.6667 9.16669C14.6667 5.48478 11.6819 2.50002 8 2.50002Z"
        fill={color || '#FDFDFD'}
      />
      <path
        d="M8 5.16669C5.79086 5.16669 4 6.95754 4 9.16669C4 10.2714 4.44698 11.2705 5.17157 11.9951C5.43192 12.2555 5.43192 12.6776 5.17157 12.9379C4.91122 13.1983 4.48911 13.1983 4.22876 12.9379C3.26435 11.9735 2.66667 10.6393 2.66667 9.16669C2.66667 6.22116 5.05448 3.83335 8 3.83335C8.36819 3.83335 8.66667 4.13183 8.66667 4.50002C8.66667 4.86821 8.36819 5.16669 8 5.16669Z"
        fill={color || '#FDFDFD'}
      />
      <path
        d="M8.66667 6.50002C8.66667 6.13183 8.36819 5.83335 8 5.83335C7.63181 5.83335 7.33333 6.13183 7.33333 6.50002V9.16669C7.33333 9.53488 7.63181 9.83335 8 9.83335C8.36819 9.83335 8.66667 9.53488 8.66667 9.16669V6.50002Z"
        fill={color || '#FDFDFD'}
      />
    </svg>
  );
}

export default IconDashboard;
